/**
 * The example ranking (15/10/2026) as the results panel reads a preview:
 * the made-up texts and prompt groups in place of the real, empty lists —
 * same formula, same columns, same score math.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenTextRankingPreview } from '@trafficpulse/shared';

export type ResultsSource = 'yours' | 'example';

/** The preview with the example's lists — or the preview itself when there is none. With no
 *  text of its own the campaign has nothing else to show, so the example stands whatever was picked. */
export function sourceView(data: DropGenTextRankingPreview, source: ResultsSource): DropGenTextRankingPreview {
  const ex = data.example;
  if (!ex || (source !== 'example' && data.totalTexts > 0)) return data;
  return { ...data, texts: ex.texts, groups: ex.groups, totalTexts: ex.totalTexts, rankedTexts: ex.rankedTexts, poolSize: ex.poolSize };
}
